import { render } from "./IndexFooter.vue?vue&type=template&id=2495c9fa&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"

import "./IndexFooter.vue?vue&type=style&index=0&id=2495c9fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2495c9fa"]])

export default __exports__